import { getAuthAxios } from "@artprov/design-system";

/**
 * Servicio para interactuar con el endpoint de matching bancario
 */

/**
 * Obtiene los registros de matching bancario
 * @returns {Promise<Array>} Array de registros de matching bancario
 */
export const getMatchingBancario = async () => {
    try {
        const response = await getAuthAxios("default").get('/matching-bancario');
        return response.data.registros || [];
    } catch (error) {
        console.error('Error al obtener matching bancario:', error);
        throw error;
    }
};

/**
 * Obtiene el detalle de un registro específico
 * @param {number} id - ID del registro
 * @returns {Promise<Object>} Detalle del registro
 */
export const getMatchingBancarioDetalle = async (id) => {
    try {
        const response = await getAuthAxios("default").get(`/matching-bancario/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error al obtener detalle de matching bancario:', error);
        throw error;
    }
};

/**
 * Obtiene el documento PDF de un email bancario
 * @param {number} id - ID del email bancario
 * @returns {Promise<Blob>} Blob del PDF
 */
export const getMatchingBancarioDocumento = async (id) => {
    try {
        const response = await getAuthAxios("default").get(
            `/matching-bancario/${id}/documento`,
            {
                timeout: 75000,
                responseType: 'blob'
            }
        );
        return response.data;
    } catch (error) {
        console.error('Error al obtener documento:', error);
        throw error;
    }
};

/**
 * Obtiene las jurisdicciones desde el catálogo
 * @returns {Promise<Array>} Array de jurisdicciones {id, descripcion}
 */
export const getJurisdicciones = async () => {
    try {
        const response = await getAuthAxios("default").get('/catalogos/jurisdicciones');
        return response.data.jurisdicciones || [];
    } catch (error) {
        console.error('Error al obtener jurisdicciones:', error);
        throw error;
    }
};

/**
 * Obtiene los fueros de una jurisdicción
 * @param {number} idJurisdiccion - ID de la jurisdicción
 * @returns {Promise<Array>} Array de fueros {id, descripcion}
 */
export const getFueros = async (idJurisdiccion) => {
    try {
        const response = await getAuthAxios("default").get(`catalogos/jurisdicciones/${idJurisdiccion}/fueros`);
        return response.data.fueros || [];
    } catch (error) {
        console.error('Error al obtener fueros:', error);
        throw error;
    }
};

/**
 * Obtiene los juzgados de una jurisdicción y fuero
 * @param {number} idJurisdiccion - ID de la jurisdicción
 * @param {number} idFuero - ID del fuero
 * @returns {Promise<Array>} Array de juzgados {id, descripcion}
 */
export const getJuzgados = async (idJurisdiccion, idFuero) => {
    try {
        const response = await getAuthAxios("default").get(`catalogos/jurisdicciones/${idJurisdiccion}/fueros/${idFuero}/juzgados`);
        return response.data.juzgados || [];
    } catch (error) {
        console.error('Error al obtener juzgados:', error);
        throw error;
    }
};

/**
 * Obtiene las secretarías de un juzgado
 * @param {number} idJuzgado - ID del juzgado
 * @returns {Promise<Array>} Array de secretarías {id, descripcion}
 */
export const getSecretarias = async (idJuzgado) => {
    try {
        const response = await getAuthAxios("default").get(`catalogos/juzgados/${idJuzgado}/secretarias`);
        return response.data.secretarias || [];
    } catch (error) {
        console.error('Error al obtener secretarías:', error);
        throw error;
    }
};

/**
 * Actualiza los datos del email bancario (9 campos editables)
 * @param {number} id - ID del email bancario
 * @param {Object} data - Datos a actualizar
 * @returns {Promise<Object>} Respuesta con matching y emailBancario actualizados
 */
export const updateEmailBancario = async (id, data) => {
    try {
        const response = await getAuthAxios("default").patch(
            `/matching-bancario/${id}`,
            data
        );
        return response.data;
    } catch (error) {
        console.error('Error al actualizar email bancario:', error);
        throw error;
    }
};
